import { Box } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import AllTenure from '../../component/AllTenure'

const TenuresPaused = () => {
  const [tData, setTData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      let response = await fetch('http://localhost:3000/tall');
      let data = await response.json();
      data = data.filter((d) => d.tenure_status === "Paused")
      setTData(data);
    }
    fetchData()
  }, [])
  return (
    <Box p={5} flex="1" w={'100%'}>
      <AllTenure
        title={"Paused Tenures"}
        head={["Tenure ID", "Order Item", "Total Rent", "Tenure Type", "Billing Date", "Expiry Dtae", "Payment Status", "Tenure Status",""]}
        data={tData}
      />
    </Box>
  )
}

export default TenuresPaused
